import { Button } from "primereact/button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { setPaymentDetails } from "src/redux/slices/lookupSlice";
import { PaymentInitiator, RoutePaths } from "src/resources/enum";

const PaymentBackButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const paymentInitiator = useSelector(
    (state: any) => state.lookup.paymentInitiator
  );
  const { t } = useTranslation(["common"]);
  const handleBack = () => {
    dispatch(setPaymentDetails({
      invoiceId: '',
      paidAmount: '',
      paymentDateAndTime:''}))
    if (paymentInitiator === PaymentInitiator.AssignedBuilding) {
      navigate(RoutePaths.AssignedBuildings);
    } else {
      navigate(RoutePaths.ViewInvoices);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center w-100">
      <Button
        label={t("return")}
        onClick={handleBack}
        className="primary-btn"
      ></Button>
    </div>
  );
};

export default PaymentBackButton;
